import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getType } from 'deox';
import { loadUserPaidItems, setUserPaidItems } from 'modules/oneTimePayment';
import { getUserKey } from 'modules/user';
import { getUserPaidItemsRequest } from 'utils/apiWrapper';
import { isNil } from 'ramda';
import { addAlert } from 'modules/alert';
import { userPaidItemsMessages } from 'constants/errorMessages';
import { UserPaidItems } from 'types/UserPaidItems';

export function* loadUserPaidItemsSaga({ payload }: ReturnType<typeof loadUserPaidItems>) {
  const userKey: string | null = yield select(getUserKey);

  if (isNil(userKey)) return;

  try {
    const userPaidItems: UserPaidItems[] = yield call(getUserPaidItemsRequest, userKey);
    yield put(setUserPaidItems(userPaidItems, payload));
  } catch (error) {
    yield put(addAlert(userPaidItemsMessages.title, userPaidItemsMessages.loadingError));
  }
}

export default function* userPaidItemsSaga() {
  yield takeEvery(getType(loadUserPaidItems), loadUserPaidItemsSaga);
}
